import React from 'react'
import { EDIT_OFFER_SCHEME_API_URL } from '../components/Shared/constant';

const EditOfferSchemeAPI = (payload, accessToken) => {
  const responce = window.axios
    .post(EDIT_OFFER_SCHEME_API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        ...result.data,
        status: 200,
      };
    })
    .catch(function (error) {
      return {
        ...error?.response?.data,
        status: error?.response?.status,
      };
    });
  return responce;
}

export default EditOfferSchemeAPI